import { Box } from 'theme-ui';
import StyledButton from '../shared/StyledButton';
import Video from '../../../src/components/old-landing/Video';
import Instructions from './Instructions';

const styles = {
  descriptionContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const DescriptionContent = ({
  staticContent,
  dynamicContent,
  button,
  isTest,
}) => {
  return (
    <Box sx={styles.descriptionContent} py='4'>
      {button && <StyledButton {...button} />}
      {isTest && (
        <Box sx={{ height: ['300px', '425px', '570px'], mt: 4, width: '100%' }}>
          <Video videoId='5NScldlmJck' />
        </Box>
      )}
      {!isTest && (
        <Instructions
          dynamicContent={{
            kicker: {
              text: dynamicContent?.joinerKicker,
              inject: [dynamicContent?.service?.name],
            },
            title: {
              text: dynamicContent?.joinerTitle,
              inject: [dynamicContent?.service?.name],
            },
            step1: {
              title: dynamicContent?.joinerStep1Title,
              description: dynamicContent?.joinerStep1Description,
              inject: [dynamicContent?.service?.name],
            },
            step2: {
              title: dynamicContent?.joinerStep2Title,
              description: dynamicContent?.joinerStep2Description,
            },
            step3: {
              title: dynamicContent?.joinerStep3Title,
              description: dynamicContent?.joinerStep3Description,
              inject: [
                dynamicContent?.monthlyPrice,
                dynamicContent?.service?.name,
              ],
            },
          }}
          staticContent={staticContent}
        />
      )}
    </Box>
  );
};

export default DescriptionContent;
